import com10 from "./MQ2-4G/commands/com-10";
import com20 from "./MQ2-4G/commands/com-20";
import com30 from "./MQ2-4G/commands/com-30";
import com40 from "./MQ2-4G/commands/com-40";
import com60 from "./MQ2-4G/commands/com-60";
import com70 from "./MQ2-4G/commands/com-70";
import com71 from "./MQ2-4G/commands/com-71";
import com72 from "./MQ2-4G/commands/com-72";
import com73 from "./MQ2-4G/commands/com-73";
import com74 from "./MQ2-4G/commands/com-74";
import com8A from "./MQ2-4G/commands/com-8A";
import com8E from "./MQ2-4G/commands/com-8E";
import com8F from "./MQ2-4G/commands/com-8F";
import com90 from "./MQ2-4G/commands/com-90";
import comA1 from "./MQ2-4G/commands/com-A1";
import comA2 from "./MQ2-4G/commands/com-A2";

const MiniQ2Commands = [
    {value: "10", name: "(0x10) Intervalo de medición continuo", type: "bytes", topic: "control", parameters: com10},
    {value: "20", name: "(0x20) Intervalo de medición simple", type: "bytes", topic: "control", parameters: com20},
    {value: "30", name: "(0x30) Intervalo de medición compuesto", type: "bytes", topic: "control", parameters: com30},
    {value: "40", name: "(0x40) Intervalo de publicación", type: "bytes", topic: "control", parameters: com40},

    {value: "5C", name: "(0x5C) Configuración de alertas", type: "bytes", topic: "control", parameters: null},
    {value: "5D", name: "(0x5D) Configuración standalone de los sensores", type: "bytes", topic: "control", parameters: null},
    {value: "5E", name: "(0x5E) Configuración múltiple de los sensores", type: "bytes", topic: "control", parameters: null},

    {value: "5F", name: "(0x5F) Admin PGA 460", type: "bytes", topic: "admin"},
    {value: "60", name: "(0x60) Configuración de parámetros de red", type: "string", topic: "admin", parameters: com60},
    {value: "70", name: "(0x70) Configuración de MQTT", type: "string", topic: "admin", parameters: com70},
    {value: "71", name: "(0x71) Configuración de MQTT de topic de datos", type: "string", topic: "admin", parameters: com71},
    {value: "72", name: "(0x72) Configuración MQTT de topic de alertas", type: "string", topic: "admin", parameters: com72},
    {value: "73", name: "(0x73) Configuración MQTT de topic de control", type: "string", topic: "admin", parameters: com73},
    {value: "74", name: "(0x74) Configuración MQTT de topic de admin", type: "string", topic: "admin", parameters: com74},
    {value: "8A", name: "(0x8A) Configuración de NTP", type: "string", topic: "admin", parameters: com8A},
    {value: "8E", name: "(0x8E) Actualización de firmware", type: "string", topic: "admin", parameters: com8E},
    {value: "8F", name: "(0x8F) Configuración del GPS", type: "string", topic: "admin", parameters: com8F},
    {value: "90", name: "(0x90) Parámetros de batería", type: "bytes", topic: "admin", parameters: com90},
    {value: "A1", name: "(0xA1) Modo de operación", type: "bytes", topic: "admin", parameters: comA1},
    {value: "A2", name: "(0xA2) Solicitud de información", type: "bytes", topic: "admin", parameters: comA2},
];
export default MiniQ2Commands;
